import React, { type FunctionComponent } from 'react'
import { Dialog } from '../Dialog'
import { Button } from '@tomra/design-system-react/button'

type Props = {
  title: string
  description?: string
  confirmButtonText: string
  cancelButtonText: string
  onCancel: () => void
  onConfirm: () => void
}

export const ConfirmDialog: FunctionComponent<Props> = ({
  title,
  description,
  cancelButtonText,
  confirmButtonText,
  onCancel,
  onConfirm
}) => {
  return (
    <Dialog ariaLabel={title}>
      <div className="card p-lg min-w-screen-sm max-w-screen-sm">
        <h1 className="font-bold text-xl mb-lg">{title}</h1>
        {description && <p>{description}</p>}

        <div className="mt-lg flex space-x-md justify-end">
          <Button onClick={onCancel}>{cancelButtonText}</Button>

          <Button variant="primary" onClick={onConfirm}>
            {confirmButtonText}
          </Button>
        </div>
      </div>
    </Dialog>
  )
}
